import { jwtDecode } from "jwt-decode";

const decodeJWTtenant = (token) => {
  try {
    const decoded = jwtDecode(token);
    // Extract roles from realm_access
    const realmTenant = decoded.realm_access?.roles || [];

    if (realmTenant.includes("tenant-es")) {
      const realmTenant = "tenant-es";
      return realmTenant;
    } else if (realmTenant.includes("tenant-gr")) {
      const realmTenant = "tenant-gr";
      return realmTenant;
    } else if (realmTenant.includes("tenant-ro")) {
      const realmTenant = "tenant-ro";
      return realmTenant;
    } else {
      const realmTenant = [];
      return realmTenant;
    }
  } catch (error) {
    console.error("Invalid token", error);
    return { realmTenant: [] };
  }
};

export default decodeJWTtenant;
